import React from "react";

export default function CasinoSuperskokMyData(props) {

    function isFinished() {
        return new Date().getTime() > new Date(props.info.aktivnoDo).getTime();
    }

    function getPlayerReward() {
        if (!props.player) return 0;
        let reward = props.finalResults.find(it => it.igracID == props.player.igracID);
        return reward ? reward.nagrada : 0;
    }

    function getDobitak() {
        if (!props.player || props.player.ordinalNumber > props.info.nagradeLista[props.info.nagradeLista.length - 1].mjesto) {
            return (
                <div className="data">
                    <div>&nbsp;</div>
                    <div className="only">Fale ti bodovi za dobitak.</div>
                </div>
            )
        } else {
            let dobitak = props.info.nagradeLista.filter(it => it.mjesto == props.player.ordinalNumber);
            if (dobitak.length == 0) dobitak = props.info.nagradeLista.filter(it => it.mjesto >= props.player.ordinalNumber);
            return (
                <div className="data">
                    <div className={ dobitak[0].nagradaOpis != null ? "nagrada-opis"  : dobitak[0].iznos >= 1000 ? "big" : ""}>
                        {dobitak[0].vrstaNagrade == null ? casino.utils.numberWithCurrencyFromated(dobitak[0].iznos, props.info.valuta) :
                            dobitak[0].vrstaNagrade == 1 && dobitak[0].nagradaOpis != null ? casino.utils.numberWithCurrencyFromated(dobitak[0].iznos, props.info.valuta) + " i " + dobitak[0].nagradaOpis :
                                dobitak[0].vrstaNagrade == 1 ? casino.utils.numberWithCurrencyFromated(dobitak[0].iznos, props.info.valuta) :
                                    dobitak[0].vrstaNagrade == 2 ? dobitak[0].nagradaOpis :
                                        dobitak[0].nagradaOpis != null ? " i " + dobitak[0].nagradaOpis :
                                            dobitak[0].vrstaNagrade == 3 ? dobitak[0].iznos + " Supera" : ""

                        }

                    </div>
                    <div>{!props.info.uplaceno ? 'trenutni dobitak' : 'isplaćeno'}</div>
                </div>
            )
        }
    }
    function getBodovi() {
        return (
            <div className="data">
                <div>{props.player ? props.player.points : 0}</div>
                <div>bodova ukupno</div>
            </div>
        )
    }

    function getPozicija() {
        return (
            <div className="data">
                <div>{props.player ? `${props.player.ordinalNumber}.` : "-"}</div>
                <div>mjesto</div>
            </div>
        )
    }

    function scrollToGames() {
        document.querySelector('#tabs').scrollIntoView({
            behavior: 'smooth'
        });
    }


    return (
        <div className="casino-superskok-section">
            <h2>Moji podaci</h2>
            <div className="my-data">
                <span className="place">
                    <span className="image">
                        {getPozicija()}
                    </span>
                </span>
                <span className="points">
                    <span className="image">
                        {getBodovi()}
                    </span>
                </span>
                <span className="points-total">
                    <span className="image">
                        {getDobitak()}
                    </span>
                </span>
            </div>

            {!isFinished() && !props.player &&
                <div className="status">
                    <div className="icon yellow"></div>
                    <div className="message">Trebaš odigrati da bi sudjelovao! Kreni sada!</div>
                    {props.info.igreSifre != null ? < a href="#" onClick={(e) => { e.preventDefault(); scrollToGames(); }} className="btn">Zaigraj</a> : < a href="" className="btn">Zaigraj</a>}
                </div>
            }
            {!isFinished() && props.player &&
                <div className="status">
                    <div className="icon green"></div>
                    <div className="message">I dalje sudjeluješ u SuperSkok utrci!</div>
                    {props.info.igreSifre != null ? < a href="#" onClick={(e) => { e.preventDefault(); scrollToGames(); }} className="btn">Zaigraj</a> : < a href="" className="btn">Zaigraj</a>}
                </div>
            }

            {isFinished() &&
                <div className="status">
                    <div className="icon green"></div>
                    <div className="message">SuperSkok utrka je završena 💪👟</div>
                    {getPlayerReward() > 0 && <div className="reward-payout">Isplaćeno ti je: <span style={{ color: '#aa0d19' }}>
                        {casino.utils.numberWithCurrencyFromated(getPlayerReward(), props.info.valuta)}</span></div>}
                </div>
            }

            <div className="divider"></div>
        </div>
    )
}